import { render, staticRenderFns } from "./QualityIndexPanel.vue?vue&type=template&id=96385112&scoped=true&"
import script from "./QualityIndexPanel.vue?vue&type=script&lang=js&"
export * from "./QualityIndexPanel.vue?vue&type=script&lang=js&"
import style0 from "./QualityIndexPanel.vue?vue&type=style&index=0&id=96385112&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96385112",
  null
  
)

export default component.exports